const API_BASE = "/wp-json/site-art/v1/forms";
const NONCE = themeSettings?.nonce;

const ENDPOINTS = {
    CONTACT: 'contact',
    QUOTE: 'quote'
};

/**
 * Bazowa funkcja do wysyłania formularzy
 * @param {keyof typeof ENDPOINTS} endpoint - Endpoint formularza
 * @param {object} formData - Dane formularza
 * @returns {Promise<object>} Odpowiedź z API
 */
const submitForm = async (endpoint, formData) => {
    try {
        if (!NONCE) {
            throw new Error('Brak wymaganego tokenu bezpieczeństwa.');
        }

        const response = await fetch(`${API_BASE}/${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': NONCE
            },
            body: JSON.stringify(formData)
        });

        const data = await response.json();

        if (data.code === 'wp_die') {
            throw new Error('Problem z serwerem, spróbuj jeszcze raz');
        }

        if (!response.ok || data.success === false) {
            throw new Error(data.message || 'Wystąpił błąd podczas wysyłania formularza.');
        }

        return {
            data: {
                success: true,
                message: data.message || 'Formularz został wysłany pomyślnie.'
            }
        };
    } catch (error) {
        return {
            error: {
                message: error.message || 'Wystąpił błąd podczas wysyłania formularza.'
            }
        };
    }
};

/**
 * Wysyłanie formularza kontaktowego
 * @param {object} formData - Dane formularza
 */
export const submitContactForm = (formData) => submitForm(ENDPOINTS.CONTACT, formData);

/**
 * Wysyłanie formularza wyceny
 * @param {object} formData - Dane formularza
 */
export const submitQuoteForm = (formData) => submitForm(ENDPOINTS.QUOTE, formData);